import React from 'react'
import styles from 'components/shared/icons/icons.module.scss'
import cn from 'classnames'
import { Clock } from 'lucide-react'

export interface HistoryIconProps {
    contextStyles?: string
    hoverStyles?: string
    selectedStyles?: string
    showIcon?: boolean
}

export default function HistoryIcon({
    contextStyles,
    hoverStyles,
    selectedStyles,
}: HistoryIconProps) {
    return (
        <div
            className={cn(
                styles.iconComp,
                styles.historyIcon,
                contextStyles,
                hoverStyles,
                selectedStyles,
            )}
        >
            <Clock />
        </div>
    )
}
